import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export const moneyMask = createNumberMask({
  prefix: '',
  suffix: '',
  integerLimit: 13,
  allowDecimal: true,
});
